import { render, staticRenderFns } from "./ApnsSettings.vue?vue&type=template&id=1baa5cd2&"
import script from "./ApnsSettings.vue?vue&type=script&lang=ts&"
export * from "./ApnsSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports